import { render } from "./HeaderControl.vue?vue&type=template&id=2cfc7e53&scoped=true"
import script from "./HeaderControl.vue?vue&type=script&lang=js"
export * from "./HeaderControl.vue?vue&type=script&lang=js"

import "./HeaderControl.vue?vue&type=style&index=0&id=2cfc7e53&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cfc7e53"]])

export default __exports__